import Api from 'src/services/ApiService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { CommonAxiosResponse } from 'src/types';
import {
  CalendarParamsState,
  FastMovingProductsPayload,
  FastMovingProductsResponse,
  SalesTimeLineResponse
} from './types';
import { getPresetDateRange } from 'src/utils';

export const getFastMovingProductsThunk = createAsyncThunk<
  CommonAxiosResponse<FastMovingProductsResponse>,
  FastMovingProductsPayload,
  { state: RootState }
>('fast-moving/getFastMovingProductsThunk', async (data) => {
  const response = await Api.get(`/products/fast_moving/get`, data);
  return response;
});

export const getSoldTimeLineThunk = createAsyncThunk<
  CommonAxiosResponse<SalesTimeLineResponse>,
  CalendarParamsState,
  { state: RootState }
>('fast-moving/getSoldTimeLineThunk', async (data) => {
  let payload = { ...data };
  // band aid solution, this will change after api is updated
  if (payload?.preset_date) {
    const rangeFromPreset = getPresetDateRange(data?.preset_date);
    payload = {
      ...payload,
      from_date: rangeFromPreset.startDate,
      to_date: rangeFromPreset.endDate
    };
  }
  const response = await Api.get(`/products/transactions/get`, payload);
  return response;
});
